module.exports = __webpack_public_path__ + "media/images/icons/putting_green_from_overhead-43ebc6448e80e8111fee5e35850065e7.png";